module.exports = __webpack_public_path__ + "media/images/about-img-10d6d98f62a4996588176fecf57ac98a.webp";